// extracted by mini-css-extract-plugin
export default {"fontFamily":"-apple-system,\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Open Sans\",\"Helvetica Neue\",\"blueprint-icons-16\",sans-serif"};